import script from "./join-us.vue?vue&type=script&setup=true&lang=js"
export * from "./join-us.vue?vue&type=script&setup=true&lang=js"

import "./join-us.vue?vue&type=style&index=0&id=0e74757e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e74757e"]])

export default __exports__